import React from 'react';
import './ShippingPolicy.css';

const TermsOfService = () => {
  return (
    <div className="terms-and-conditions-container">
      <div className="policy-title">Terms of Service</div>

      <div className="policy-section">
        <p>Swapnil Sharma Print Company makes available information and materials on its website <a href="https://www.swapnilsharma.in" target="_blank" rel="noopener noreferrer">www.swapnilsharma.in</a> subject to the following terms and conditions ("Terms of Service"). Your use of www.swapnilsharma.in constitutes your agreement to follow and be bound by these Terms of Service. If you do not agree to the Terms of Service, you may not use the site. Swapnil Sharma Print Company reserves the right to change these Terms of Service periodically without prior notice.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Contact</div>
        <p>For queries, you can connect with us at <a href="mailto:info@swapnilsharma.in">info@swapnilsharma.in</a>.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Domestic Shipping</div>
        <p>All orders are usually shipped within 5-7 working days (unless otherwise noted in the product description section), so you can expect delivery within 7-10 days. A tracking link will be sent to your inbox once your order is shipped; please allow 24 hours for tracking status updates.</p>
        <p>If the delivery address is challenging to access, delivery time may exceed our estimate. We may contact you via the email or phone number you provided to confirm the delivery address.</p>
        <p>We use reliable courier companies and/or Speed Post. Swapnil Sharma Print Company is not liable for delays by the courier company or Speed Post or for factors outside of Swapnil Sharma Print Company’s control. We will strive to ensure the timely delivery of your order within the estimated timeframe as noted in the order confirmation.</p>
        <p>In the unlikely event that delivery is not possible for reasons outside Swapnil Sharma Print Company's control, including poor courier services in your area, inaccessible delivery locations, or force majeure events, we will inform you and cancel your order, followed by a full refund.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Return / Refund / Replacement</div>
        <p>Swapnil Sharma Print Company does not accept any type of return.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Cancellation</div>
        <p>Since each print is made-to-order, we do not accept any cancellation requests.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Processing Orders</div>
        <p>Our business hours are 10:00 AM to 6:00 PM Indian Standard Time (IST) Monday through Friday. For any queries, write to us at <a href="mailto:info@swapnilsharma.in">info@swapnilsharma.in</a>, and we will respond as soon as possible.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Customer Service Policy</div>
        <p>Swapnil Sharma Print Company is committed to exceptional customer service and quality products. We strive to keep all products listed on our website in stock and ensure accurate pricing. Delivery time frames range from 3-14 business days. If an item is not available, we will notify you within 5 business days to arrange an agreeable alternative item, backorder, or refund.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Care Instructions</div>
        <p>Swapnil Sharma Print Company assumes no liability for damage or quality issues due to improper or reckless use of products or disregard of care instructions.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Measurements/Dimensions of Products</div>
        <p>Product measurements are approximate and intended to give an estimate of size. Actual dimensions may vary slightly.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Copyright & Intellectual Property</div>
        <p>The trademark “Swapnil Sharma Print Company" is proprietary to Swapnil Sharma Print Company. The website (<a href="https://www.swapnilsharma.in" target="_blank" rel="noopener noreferrer">swapnilsharma.in</a>) and all content, including text, illustrations, and images, are created and owned by Swapnil Sharma Print Company.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Jurisdiction</div>
        <p>All disputes are subject to the courts of Madhya Pradesh jurisdiction.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Legal Information</div>
        <p>All design and content featured on <a href="https://www.swapnilsharma.in" target="_blank" rel="noopener noreferrer">swapnilsharma.in</a> - including navigational buttons, images, artwork, graphics, photography, and text, are copyrights and trademarks owned by Swapnil Sharma Print Company, intended solely for personal, non-commercial use. Unauthorized reproduction or use is prohibited.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Limitation of Liability</div>
        <p>Swapnil Sharma Print Company does not warrant uninterrupted or error-free operation of this website. Users are responsible for any costs associated with using our website. Swapnil Sharma Print Company shall not be liable for damages related to your use of or inability to access the website.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Inaccuracies</div>
        <p>We strive to present accurate information but may occasionally have typographical errors or inaccuracies. We reserve the right to correct any errors or update information at any time. If a product is listed at an incorrect price, Swapnil Sharma Print Company reserves the right to cancel orders placed for that product. In such cases, we will issue a credit to your account if payment has been processed.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Availability, Product Information, Pricing & Colors</div>
        <p>Many items are offered in limited quantities, and once sold out, they may not return to stock. We attempt to display product colors accurately but cannot guarantee they match the display on your monitor.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Indemnification</div>
        <p>You agree to indemnify Swapnil Sharma Print Company, its employees, and agents from losses or damages resulting from any violation of these terms by you or anyone accessing the site through your account.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Correspondence</div>
        <p>Swapnil Sharma Print Company is under no obligation to respond to all correspondence or maintain confidentiality for comments submitted through this site.</p>
      </div>

      <div className="policy-section">
        <div className="section-title">Contact Us</div>
        <p>We welcome questions, feedback, and ideas. You can reach us at <a href="mailto:info@swapnilsharma.in">info@swapnilsharma.in</a>.</p>
      </div>
    </div>
  );
};

export default TermsOfService;
